import { api } from './api'
import { Provider, ProviderFormData, ProviderFilters } from '../types/referral'

export const providerService = {
  /**
   * Get all providers with optional filters
   */
  getAll: async (filters?: ProviderFilters): Promise<Provider[]> => {
    const params: Record<string, string> = {}
    if (filters?.type) params.type = filters.type
    if (filters?.specialty) params.specialty = filters.specialty
    if (filters?.isActive !== undefined) params.isActive = filters.isActive.toString()

    const response = await api.get<Provider[]>('/providers', { params })
    return response.data
  },

  /**
   * Get single provider by ID
   */
  getById: async (id: string): Promise<Provider> => {
    const response = await api.get<Provider>(`/providers/${id}`)
    return response.data
  },

  /**
   * Create new provider
   */
  create: async (data: ProviderFormData): Promise<Provider> => {
    const response = await api.post<Provider>('/providers', data)
    return response.data
  },

  /**
   * Update existing provider
   */
  update: async (id: string, data: Partial<ProviderFormData>): Promise<Provider> => {
    const response = await api.put<Provider>(`/providers/${id}`, data)
    return response.data
  },

  /**
   * Deactivate provider (soft delete)
   */
  delete: async (id: string): Promise<Provider> => {
    const response = await api.delete<Provider>(`/providers/${id}`)
    if (!response || !response.data) {
      throw new Error('Failed to delete provider')
    }
    return response.data
  },
}
